import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

export const Index = { auth: authRoles.admin, routes: [{ path: '/driver-stats', component: FuseLoadable({ loader: () => import('./DriverStatsApp') }) }] };

export default [Index];
